import { Injectable } from '@angular/core';

import { Operation, Widget, Ambassador } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class DataService {
    
    ambassador: Ambassador = new Ambassador();
    operation: Operation = new Operation();
    widget: Widget = new Widget();
    
    resetLogout(){
        this.ambassador = new Ambassador();
    }
    
    resetOperation(){
        this.operation = new Operation();
        this.widget = new Widget();
    }
    
    resetAll(){
        this.resetLogout();
        this.resetOperation();
    }
    
}
